import "./ResultsWidget.css";
import React from "react";

const BlockResultsWidget = ({ farm, analysis, block }) => {
    let latestResults = block.currentResults || {};
    if (analysis.class === "Budget") {
        const { offlineBudgets = [] } = farm;
        const offlineBudget = offlineBudgets.find((b) => b.id === analysis.id);
        if (!offlineBudget || offlineBudget.isDirty) {
            latestResults = {};
        }
    }

    const nPerHa = latestResults.nitrogenOverview && latestResults.nitrogenOverview.lostToWater >= 0 && latestResults.nitrogenOverview.lostToWater.toLocaleString();
    const nTotal = latestResults.nitrogenOverview && latestResults.nitrogenOverview.totalLost >= 0 && latestResults.nitrogenOverview.totalLost.toLocaleString();
    const pPerHa = latestResults.phosphorusOverview && latestResults.phosphorusOverview.lostToWater >= 0 && latestResults.phosphorusOverview.lostToWater.toLocaleString();
    const pTotal = latestResults.phosphorusOverview && latestResults.phosphorusOverview.totalLost >= 0 && latestResults.phosphorusOverview.totalLost.toLocaleString();

    return (
        <div className="results-widget">
            <div className="results-widget__nutrient results-widget__nutrient--n">
                <div className="results-widget__name">N</div>
                <div className="results-widget__item">
                    <span className="results-widget__value" id={`${block.id}-nLost-ha`}>
                        {nPerHa || "-"}
                    </span>
                    {nPerHa && <span className="results-widget__uom">kg/ha</span>}
                </div>
                {nTotal && (
                    <>
                        <div className="results-widget__divider">|</div>
                        <div className="results-widget__item">
                            <span className="results-widget__value" id={`${block.id}-nLost`}>
                                {nTotal}
                            </span>
                            <span className="results-widget__uom">kg</span>
                        </div>
                    </>
                )}
            </div>
            <div className="results-widget__nutrient results-widget__nutrient--p">
                <div className="results-widget__name">P</div>
                <div className="results-widget__item">
                    <span className="results-widget__value" id={`${block.id}-pLost-ha`}>
                        {pPerHa || "-"}
                    </span>
                    {pPerHa && <span className="results-widget__uom">kg/ha</span>}
                </div>
                {pTotal && (
                    <>
                        <div className="results-widget__divider">|</div>
                        <div className="results-widget__item">
                            <span className="results-widget__value" id={`${block.id}-pLost`}>
                                {pTotal}
                            </span>
                            <span className="results-widget__uom">kg</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default BlockResultsWidget;
